const initialState = {
    c: 1,
    b: 22
}

export default (state = initialState, action) => {
    if (action.type === "alert") {
        console.log(action.evt);

        return { ...state, c: state.c + 1 }
    }
    if (action.type === "updateB") {

        return { ...state, b: action.payload.newb }
    }
    return state;
}